<template>
  <div :class="'custom_input textarea'+width">
    <div class="label">
      {{ capitalisedLabel }}
    </div>
    <div
      v-if="htmlEditor"
      class="btn"
      @click="toggleHTML"
    >
      HTML Mode
    </div>
    <textarea :id="`${id}`" />
    <small
      v-for="(error, index) in validationErrors"
      :key="index"
      class="validation"
    >{{ error }}</small>
  </div>
</template>
<script>
import _ from 'lodash';
import $ from 'jquery';
import svgIcons from 'trumbowyg/dist/ui/icons.svg';

export default {
  props: {
    id: {
      type: String,
      default: "trumbowyg",
    },
    htmlEditor: {
      type: Boolean,
      default: false
    },
    htmlInput: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    modelValue: {
      type: String,
      required: false,
      default: null
    },
    width: {
      type: String,
      required: false,
      default: 'full'
    },
    height: {
      type: Number,
      required: false,
      default: 250
    },
    validationErrors: {
      type: Object,
      required: false,
      default: null,
    },
    font: {
      type: String,
      required: false,
      default: 'DM Sans, sans-serif'
    },
    btns: {
      type: Array,
      required: false,
      default() {
        return [
          ['strong', 'em', 'del'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['unorderedList', 'orderedList'],
          ['horizontalRule'],
          ['link'],
          ['foreColor', 'fontfamily', 'fontsize'],
          ['removeformat'],
          ['fullscreen']
        ];
      },
    }
  },
  emits: ['update:modelValue'],
  computed: {
    calcHeight() {
      return this.height + 'px';
    },
    capitalisedLabel() {
      let words = this.label.split(' ');
      _.each(words, (word, index) => {
        words[index] = _.capitalize(word);
      });
      return words.join(' ');
    }
  },
  watch: {
    modelValue(newValue) {
      $(`#${this.id}`).trumbowyg('html', newValue);
    }
  },
  mounted() {
    // Prep and init Trumbowyg
    $.trumbowyg.svgPath = svgIcons;
    $(`#${this.id}`).trumbowyg({
      resetCss: false,
      removeformatPasted: true,
      btns: this.btns,
      plugins: {
        colors: {
          colorList: [
            '040707', '0074D9', '7FDBFF', '39CCCC', 'B10DC9', 'F012BE', '85144b', 'FF4136', 'FF851B', 'FFDC00', '3D9970', '2ECC40', '01FF70', 'AAA', 'DDD', 'FFF'
          ]
        },
        fontfamily: {
          fontList: [
            {name: 'DM Sans', family: 'DM Sans, sans-serif'},
            {name: 'Arial', family: 'Arial, Helvetica, sans-serif'},
            {name: 'Cambria', family: 'Cambria, Cochin, Georgia, Times, Times New Roman, serif'},
            {name: 'Courier New', family: 'Courier New, Courier, monospace'},
            {name: 'Franklin Gothic Medium', family: 'Franklin Gothic Medium, Arial Narrow, Arial, sans-serif'},
            {
              name: 'Lucida Sans',
              family: 'Lucida Sans, Lucida Sans Regular, Lucida Grande, Lucida Sans Unicode, Geneva, Verdana, sans-serif'
            },
            {
              name: 'Roboto',
              family: 'Roboto, -apple-system, system-ui, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif'
            },
            {name: 'Times New Roman', family: 'Times New Roman, Times, serif'},
          ]
        }
      }
    })
        .on('tbwchange', () => {
          this.$emit('update:modelValue', $(`#${this.id}`).trumbowyg('html'));
        });

    if (this.htmlInput) {
      $(`#${this.id}`).trumbowyg('toggle');
    }
    $(`#${this.id}`).trumbowyg('html', this.modelValue);

  },
  methods: {
    updateValue() {
      this.$emit('update:modelValue', this.modelValue)
    },
    toggleHTML() {
      $(`#${this.id}`).trumbowyg('toggle');
    }
  }

};
</script>
<style scoped>
@import "trumbowyg/dist/ui/trumbowyg.min.css";
@import "trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.min.css";

.full {
  width: 100%;
}

.two-thirds {
  width: calc(66.66% - .5rem);
}

.half {
  width: calc(50% - .5rem);
}

.third {
  width: calc(33.33% - .5rem);
}

.quarter {
  width: calc(25% - .5rem);
}

.label {
  font-size: 0.75rem;
  line-height: 1.3;
  letter-spacing: -0.1px;
  color: #909096;
}

.validation {
  text-align: center;
  color: red;
  margin-left: 10px;
}

.trumbowyg {
  margin-top: 0px !important;
}

.trumbowyg-editor ol, .trumbowyg-editor ul {
  list-style: initial;
  padding: unset;
  padding-inline-start: 40px;
}

.trumbowyg-editor ul {
  list-style-type: disc;
  list-style-position: inside;
  line-height: 1.9;
  color: #455560;
}

.trumbowyg-editor ol {
  list-style-type: decimal;
  list-style-position: inside;
  line-height: 1.9;
  color: #455560;
}

.custom_input .textarea {
  font-family: v-bind('font');
}

.trumbowyg-editor p {
  font-family: inherit !important;
}

.trumbowyg-modal-box .trumbowyg-input-infos label {
  margin: 0;
}
</style>

<style scoped>
.full {
  width: 100%;
}

.two-thirds {
  width: calc(66.66% - .5rem);
}

.half {
  width: calc(50% - .5rem);
}

.third {
  width: calc(33.33% - .5rem);
}

.quarter {
  width: calc(25% - .5rem);
}

.label {
  font-size: 0.75rem;
  line-height: 1.3;
  letter-spacing: -0.1px;
  color: #909096;
}

.validation {
  text-align: center;
  color: red;
  margin-left: 10px;
}

.custom_input {
  font-family: v-bind('font');
}

.textarea {
  width: 100%;
  height: v-bind('calcHeight');
  color: #4E4E54;
  background-color: #fff;
  border: 1px solid #E8E5E2;
  padding: 14.5px 24.5px 15.5px;
  border-radius: 12px;
  font-size: 14px;
  letter-spacing: -0.5px;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
}

.label {
  margin-bottom: .25rem;
  font-size: 0.75rem;
  line-height: 1.3;
  letter-spacing: -0.1px;
  color: #909096;
}

.sub_label {
  float: right;
  font-size: .625rem;
  line-height: 1.3;
  letter-spacing: -0.015em;
  color: #909096;
}

.textarea::-webkit-input-placeholder {
  color: #9999a3;
  -webkit-transition: .3s;
  transition: .3s;
}

.textarea::-moz-placeholder {
  color: #9999a3;
  -moz-transition: .3s;
  transition: .3s;
}

.textarea:-ms-input-placeholder {
  color: #9999a3;
  -ms-transition: .3s;
  transition: .3s;
}

.textarea::-ms-input-placeholder {
  color: #9999a3;
  -ms-transition: .3s;
  transition: .3s;
}

.textarea::placeholder {
  color: #9999a3;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
}

.textarea:focus::-webkit-input-placeholder {
  color: transparent;
}

.textarea:focus::-moz-placeholder {
  color: transparent;
}

.textarea:focus:-ms-input-placeholder {
  color: transparent;
}

.textarea:focus::-ms-input-placeholder {
  color: transparent;
}

.textarea:focus::placeholder {
  color: transparent;
}

.validation {
  text-align: center;
  color: red;
  margin-left: 10px;
}

textarea[disabled] {
  pointer-events: none;
}
</style>
